"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DBDependenciesManyToOne = exports.DBDependenciesOneToMany = void 0;
const network_constants_1 = require("./network.constants");
const person_data_1 = require("./person.data");
const hunting_district_dto_1 = require("./hunting-district.dto");
const event_data_1 = require("./event.data");
const event_invitation_data_1 = require("./event-invitation.data");
/**
 * Central location for configuring the dependencies between collections
 */
exports.DBDependenciesOneToMany = new Map([
    [
        network_constants_1.NetworkConstants.COLLECTION_PERSON, new Map([
            // all dependencies from Person -> [Collection]
            [network_constants_1.NetworkConstants.COLLECTION_EVENT_INV, person_data_1.DependencyPersonToEventInvitation],
        ]),
    ],
    [
        // all dependencies from HuntingDistrict -> [Collection]
        network_constants_1.NetworkConstants.COLLECTION_HUNTING_DISTRICT, new Map([
            [network_constants_1.NetworkConstants.COLLECTION_EVENT_INV, hunting_district_dto_1.DependencyHuntingDistrictToEventInvitation],
        ])
    ],
    [
        network_constants_1.NetworkConstants.COLLECTION_EVENT, new Map([
            // all dependencies from Event -> [Collection]
            [network_constants_1.NetworkConstants.COLLECTION_EVENT_INV, event_data_1.DependencyEventToEventInvitation],
        ])
    ]
]);
exports.DBDependenciesManyToOne = new Map([
    [
        network_constants_1.NetworkConstants.COLLECTION_EVENT_INV, new Map([
            [network_constants_1.NetworkConstants.COLLECTION_PERSON, event_invitation_data_1.DependencyEventInvitationToPerson],
            [network_constants_1.NetworkConstants.COLLECTION_EVENT, event_invitation_data_1.DependencyEventInvitationToEvent],
            [network_constants_1.NetworkConstants.COLLECTION_HUNTING_DISTRICT, event_invitation_data_1.DependencyEventInvitationToHuntingDistrict]
        ])
    ],
]);
